module.exports = __webpack_public_path__ + "img/btn-room-actions.5890c729.svg";